import React from 'react';
import { Region } from '../../../data/regions';
import ChurchesMap from './ChurchesMap';
import ChurchesList from './ChurchesList';
import MissionaryTeam from './MissionaryTeam';
import { useState } from 'react';
import { Church, Missionary } from './types';
import { useMockChurchData } from './useMockChurchData';
import { useLanguage } from '../../../contexts/language';

interface ChurchesViewProps {
  region: Region;
}

const ChurchesView: React.FC<ChurchesViewProps> = ({ region }) => {
  const { t, language } = useLanguage();
  const { churches, missionaries, loading } = useMockChurchData(region);
  const [selectedChurch, setSelectedChurch] = useState<Church | null>(null);
  
  const flyToChurch = (church: Church) => {
    setSelectedChurch(church);
  };
  
  const resetMapView = () => {
    setSelectedChurch(null);
  };
  
  return (
    <div className="space-y-6">
      <div className="text-sm text-gray-500">
        {t('churchesInRegion', { region: language === 'en' ? region.english_name : region.spanish_name })}
      </div>
      
      {/* Map view */}
      <ChurchesMap 
        region={region}
        churches={churches} 
        selectedChurch={selectedChurch}
        onChurchSelect={flyToChurch}
        onResetView={resetMapView}
      />
      
      {/* Selected church missionaries */}
      {selectedChurch && missionaries[selectedChurch.id] && (
        <MissionaryTeam 
          church={selectedChurch} 
          missionaries={missionaries[selectedChurch.id]} 
        />
      )}
      
      {/* Churches list */}
      <ChurchesList
        churches={churches}
        loading={loading}
        selectedChurchId={selectedChurch?.id}
        onChurchSelect={flyToChurch}
      />
    </div>
  );
};

export default ChurchesView;
